import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import App from '@app/App';
import store from '@store';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'admin-lte/dist/js/adminlte';

import './index.scss';
import './i18n';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <Provider store={store}>
        <App />
        <ToastContainer
            autoClose={3000}
            draggable={false}
            position="top-right"
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick={true}
            rtl={false}
            pauseOnFocusLoss={true}
            pauseOnHover={true}
        />
    </Provider>
);
